export default "__VITE_ASSET__2NgXdQAp__"